import React from 'react';
import { ErrorBoundary, MillionaireGame } from './components';
import './App.css';

const App: React.FC = () => {
  return (
    <ErrorBoundary
      title="¡Vaya! Algo ha fallado"
      message="La aplicación ha encontrado un error inesperado. Recarga la página para continuar."
      resetLabel="Recargar página"
      onReset={() => window.location.reload()}
    >
      <MillionaireGame />
    </ErrorBoundary>
  );
};

export default App;
